import AxiosInstance from "services/api";

export const ExpenseReportService = {
  async getPaginate(query) {
    return await AxiosInstance.get("/private/expense-report", { params: query });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/expense-report/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post("/private/expense-report", payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/expense-report/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/expense-report/${id}`);
  },
};
